import store from "../../../store";
import { obterMensagemErroResponse, obterMensagemResponse } from "../../../shared/helper/RequestUtil";
import { showSuccess } from "../../../shared/helper/messages";
import { deleteSeguro, getSeguro, getSeguroPromise, postSeguroPromise, putSeguroPromise } from "../../../shared/helper/requests";
import { atualizarValorCampoAdicionalPorSigla } from "../dadosPedido/helper";
import { gerarListaDeCamposExigenciaAposAlteracaoDoCampo } from "./helper";

export const iniciarDetalhar = () => ({
  type: 'REQUERIMENTO_DETALHAR_TAREFA_CONSULTAR_INICIAR'
})

export const iniciarDetalharExigencia = () => ({
  type: 'REQUERIMENTO_DETALHAR_EXIGENCIA_INICIAR'
})

export const finalizarDetalharExigencia = () => ({
  type: 'REQUERIMENTO_DETALHAR_EXIGENCIA_FINALIZAR'
})

export  function  consultarTarefaPorProtocolo(protocolo, keepMessage = false) {
  return  (dispatch, getState) => {
            dispatch(iniciarDetalhar());
            let { nome } = getState().session.usuario;
    return  getSeguro(
      dispatch,
      `SagService/tarefa/${protocolo}?nome=${nome}`,
      dados => dispatch(receberDadosSucesso(dados, keepMessage)),
      dispatch(receberDadosErro)
    );
  }
}

export  function  consultarTarefaPorProtocoloPromise(protocolo) {
  const nome = store.getState().session.usuario?.nome ?? "";
  return getSeguroPromise(`SagService/tarefa/${protocolo}?nome=${nome}`);
}

export function consultarTarefaSimplificadaPromise(protocolo) {
  const url = `SagService/tarefa/${protocolo}/simples`;
  return getSeguroPromise(url);
}

export const receberDadosSucesso = (dados, keepMessage) => {
  if (keepMessage) {
    return ({
      type: 'REQUERIMENTO_DETALHAR_TAREFA_CONSULTAR_SUCESSO_INCOMPATIVEL',
      payload: dados
    });
  } else {
    return ({
      type: 'REQUERIMENTO_DETALHAR_TAREFA_CONSULTAR_SUCESSO',
      payload: dados
    });
  }
}

export const receberDadosErro = erro => ({
  type: 'REQUERIMENTO_DETALHAR_TAREFA_CONSULTAR_ERRO',
  payload: erro
});

export const closeMessage = (keepMessage = false) => ({
  type: 'REQUERIMENTO_DETALHAR_CLOSE_MESSAGE'
})

export const exibirAlertaProrrogacao = alerta => {
  return ({
    type: "REQUERIMENTO_PRORROGACAO_EXIBIR_ALERTA",
    payload: alerta
  })
}

/** PROCURADOR */

export const handleProcurador = (atributo, valor) => ({
  type: 'REQUERIMENTO_DETALHAR_HANDLE_ATRIBUTO_PROCURADOR',
  payload: { atributo, valor }
})

export const iniciarIncluirProcurador = () => ({
  type: 'REQUERIMENTO_DETALHAR_INICIAR_INCLUIR_PROCURADOR'
});

export function incluirProcurador(cpfCnpjProcurador, nomeProcurador, protocolo) {
  return function (dispatch, getState) {
    let tipoPessoaRepresentante = cpfCnpjProcurador.match(/^\d{11}$/) ? 'PESSOA_FISICA' : 'PESSOA_JURIDICA';
    let { cpfProcurador, cnpj } = tipoPessoaRepresentante === 'PESSOA_FISICA' ?
      { cpfProcurador: cpfCnpjProcurador, cnpj: '' } : { cpfProcurador: '', cnpj: cpfCnpjProcurador };

    dispatch(iniciarIncluirProcurador());
    let novoProcurador = {
      cpf: cpfProcurador,
      nome: nomeProcurador,
      cnpj,
      tipoPessoaRepresentante
    };
    let { cpf, nome } = getState().session.usuario;
    let queryParams = `?nome=${nome}&cpf=${cpf}&codTipoCanalAtendimento=1`;
    return postSeguroPromise(`SagService/tarefa/${protocolo}/v2/procurador${queryParams}`, novoProcurador);
  }
}

export const incluirProcuradorSucesso = dados => {
  showSuccess("Inclusão do procurador efetuada com sucesso");
  return ({
    type: 'REQUERIMENTO_DETALHAR_INCLUIR_PROCURADOR_SUCESSO',
    payload: dados
  })
};

export const incluirProcuradorErro = erro => ({
  type: 'REQUERIMENTO_DETALHAR_INCLUIR_PROCURADOR_ERRO',
  payload: obterMensagemErroResponse(erro)
});

export const iniciarRemoverProcurador = () => ({
  type: 'REQUERIMENTO_DETALHAR_INICIAR_REMOVER_PROCURADOR'
});

export function removerProcurador(idProcurador, protocolo, tipoPessoaRepresentante) {
  return function (dispatch, getState) {
    dispatch(iniciarRemoverProcurador());
    let { cpf, nome } = getState().session.usuario;
    let queryParams = `?nome=${nome}&cpf=${cpf}&codTipoCanalAtendimento=1&tipoPessoaRepresentante=${tipoPessoaRepresentante}`;
    return deleteSeguro(dispatch, `SagService/tarefa/${protocolo}/v2/procurador/${idProcurador}${queryParams}`, (dados) => removerProcuradorSucesso(dados, protocolo), removerProcuradorErro);
  }
}

export const removerProcuradorSucesso = (dados, protocolo) => {
  showSuccess(obterMensagemResponse(dados))
  return function (dispatch) {
    dispatch(consultarTarefaPorProtocolo(protocolo));
    return ({
      type: 'REQUERIMENTO_DETALHAR_REMOVER_PROCURADOR_SUCESSO'
    })
  }
};

export const removerProcuradorErro = erro => ({
  type: 'REQUERIMENTO_DETALHAR_REMOVER_PROCURADOR_ERRO',
  payload: obterMensagemErroResponse(erro)
})

export const showMessageSucessoDetalhar = (mensagem) => ({
  type: 'REQUERIMENTO_DETALHAR_SHOW_SUCCESS_MESSAGE',
  payload: mensagem
});

/** CUMPRIR EXIGENCIA */
export const iniciaEnvioComentario = () => ({ type: 'REQUERIMENTO_EXIGENCIA_INCLUIR_COMENTARIO' });

export const enviarComentarioSucesso = () => ({
  type: 'REQUERIMENTO_EXIGENCIA_COMENTARIO_SUCESSO'
});

export const enviarComentarioErro = error => {
  return { type: 'REQUERIMENTO_EXIGENCIA_COMENTARIO_ERRO', payload: obterMensagemErroResponse(error) };
};

export const exibirAlertaDetalhar = message => {
  return { type: 'REQUERIMENTO_DETALHAR_EXIBIR_ALERTA', payload: message };
};

export const enviarComentario = (comentarioData, protocolo) => {
  return async dispatch => {
    return putSeguroPromise(`SagService/tarefa/v3/${protocolo}/comentario`, JSON.stringify(comentarioData));
  };
};

const preparaJSONComAnexos = anexos => {
  if (!anexos || anexos.length === 0) {
    return "";
  }

  const jsonAnexos = anexos.map((anexo) => {
    return {
      nomeArquivo: anexo.nomeArquivo,
      descricaoArquivo: anexo.descricao || "",
      tamanho: anexo.tamanhoAnexo,
      idConteudoArquivo: anexo.idConteudoAnexo,
      extensaoArquivo: anexo.nomeArquivo?.split(".").pop(),
      indicadorAutenticacao: "0",
    };
  });

  return `, "anexos": ${JSON.stringify(jsonAnexos)}`;
}

export const detalharDespachoSucesso = despacho => ({
  type: 'REQUERIMENTO_DETALHAR_DESPACHO_CONSULTAR_SUCESSO',
  payload: despacho
});

export const iniciarConsultarHistoricoAgendamentos = () => ({
  type: 'REQUERIMENTO_DETALHAR_AGENDAMENTOS_CONSULTAR_INICIAR'
});

export const consultarHistoricoAgendamentoSucesso = (dados) => {
  return {
    type: 'REQUERIMENTO_DETALHAR_AGENDAMENTOS_CONSULTAR_SUCESSO',
    payload: Array.isArray(dados) && dados[0] ? dados : []
  }
}

export const receberErroHistoricoAgendamento = erro => ({
  type: 'REQUERIMENTO_DETALHAR_AGENDAMENTOS_CONSULTAR_ERRO',
  payload: obterMensagemErroResponse(erro)
});

export const iniciarConsultarAgendamentoPericia = () => ({
  type: 'REQUERIMENTO_DETALHAR_AGENDAMENTO_POR_ID_INICIAR'
});

export function consultarAgendamentoPericiaPorID(idAgendamento) {
  return (dispatch, getState) => {
    let { cpf } = getState().session.usuario;
    dispatch(iniciarConsultarAgendamentoPericia());
    return getSeguro(
      dispatch,
      `PericiaService/agendamento/v2/${idAgendamento}?cpf=${cpf}`,
      receberSucessoConsultarAgendamentoPericiaPorID,
      receberErroConsultarAgendamentoPericiaPorID
    );
  }
}

export const receberErroConsultarAgendamentoPericiaPorID = erro => ({
  type: 'REQUERIMENTO_DETALHAR_AGENDAMENTO_POR_ID_ERRO',
  payload: obterMensagemErroResponse(erro)
});

export const receberSucessoConsultarAgendamentoPericiaPorID = agendamento => ({
  type: 'REQUERIMENTO_DETALHAR_AGENDAMENTO_POR_ID_SUCESSO',
  payload: agendamento
});

export function consultarFragmentoPorSigla(sigla) {
  return (dispatch) => {
    return getSeguro(
      dispatch,
      `SagService/tarefa/fragmento/${sigla}`,
      receberFragmentoSucesso,
      receberFragmentoErro
    );
  }
}

export const receberFragmentoSucesso = fragmento => {
  return {
    type: 'DETALHAR_FRAGAMENTO_POR_SIGLA_SUCESSO',
    payload: fragmento
  }
}

export const receberFragmentoErro = erro => ({
  type: 'DETALHAR_FRAGAMENTO_POR_SIGLA_ERRO',
  payload: obterMensagemErroResponse(erro)
});

export function consultarServicoPorId(idServico) {
  return (dispatch) => {
    return getSeguro(
      dispatch,
      `SagService/servico/${idServico}`,
      receberSucessoDadosServico,
      receberErroDadosServico
    );
  }
}

export const receberSucessoDadosServico = servico => {
  return {
    type: 'REQUERIMENTO_DETALHAR_SERVICO_POR_ID_SUCESSO',
    payload: servico
  }
}

export const receberErroDadosServico = erro => ({
  type: 'REQUERIMENTO_DETALHAR_SERVICO_POR_ID_ERRO',
  payload: obterMensagemErroResponse(erro)
});

export const receberErroValidacaoTarefaIncompativel = (error) => ({
  type: "REQUERIMENTO_DADOS_PEDIDO_VALIDAR_TAREFA_INCOMPATIVEL_ERROR",
  payload: error,
});


export function consultarCamposAdicionaisServicoPorId(idServico) {
  return (dispatch) => {
    dispatch(iniciarConsultaCamposAdicionaisServicoPorId());
    return getSeguro(
      dispatch,
      `SagService/servico/${idServico}/camposadicionais?codSistema=6`,
      receberSucessoCamposAdicionaisServico,
      receberErroCamposAdicionaisServico
    );
  }
}

export const iniciarConsultaCamposAdicionaisServicoPorId = () => ({
  type: 'REQUERIMENTO_DETALHAR_CAMPOS_ADICIONAIS_SERVICO_POR_ID_INICIAR'
});

export const receberSucessoCamposAdicionaisServico = dados => {
  return {
    type: 'REQUERIMENTO_DETALHAR_CAMPOS_ADICIONAIS_SERVICO_POR_ID_SUCESSO',
    payload: dados
  }
}

export const receberErroCamposAdicionaisServico = erro => ({
  type: 'REQUERIMENTO_DETALHAR_CAMPOS_ADICIONAIS_SERVICO_POR_ID_ERRO',
  payload: obterMensagemErroResponse(erro)
});

export const definirListaCampoExigencia = (camposExigencia) => ({
  type: 'REQUERIMENTO_DETALHAR_DEFINIR_LISTA_CAMPO_EXIGENCIA',
  payload: camposExigencia
});

export const alterarCampoExigenciaPorSigla = (sigla, value) => {
  return (dispatch, getState) => {
    const campos =
      getState().requerimentos.detalhar.camposExigencia;
    const campoModificado = atualizarValorCampoAdicionalPorSigla(campos, sigla, value);
    const listaModificada = gerarListaDeCamposExigenciaAposAlteracaoDoCampo(campoModificado, campos);
    return dispatch({
      type: "REQUERIMENTO_DETALHAR_ALTERAR_LISTA_CAMPO_EXIGENCIA",
      payload: listaModificada,
    });
  };
}

export const refreshDetalharTarefa = () => ({
  type: 'REQUERIMENTO_DETALHAR_REFRESH_TAREFA'
})

export function checkPodeRealizarAnaliseDocumental(protocolo) {
  const url = `SagService/tarefa/${protocolo}/pode-realizar-analise-documental`
  return (dispatch) => {
    return getSeguro(
      dispatch,
      url,
      podeRealizarAnaliseDocumentalSucesso,
      podeRealizarAnaliseDocumentalErro
    );
  }
}

const solicitacaoPodeRealizarAnaliseDocumental = () => ({
  type: "SOLICITACAO_PODE_REALIZAR_ANALISE_DOCUMENTAL",
});

const podeRealizarAnaliseDocumentalSucesso = (data) => {
  return {
    type: "PODE_REALIZAR_ANALISE_DOCUMENTAL_SUCESSO",
    payload: data
  }
};

const podeRealizarAnaliseDocumentalErro = (erro) => {
  return {
    type: "PODE_REALIZAR_ANALISE_DOCUMENTAL_ERRO",
    message: erro
  }
};